import { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "./AdminLayout.css";

export default function AdminLayout() {
  const { usuario, cerrarSesion, esSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const NAV = [
    { to: "/admin/dashboard", icon: "📊", label: "Dashboard" },
    { to: "/admin/properties", icon: "🏠", label: "Propiedades" },
    { to: "/admin/contacts", icon: "📩", label: "Leads" },
    { to: "/admin/ciudades", icon: "🏙️", label: "Ciudades" },
    { to: "/admin/estados", icon: "🗺️", label: "Estados" },
    // Solo super_admin ve la sección de usuarios
    ...(esSuperAdmin ? [{ to: "/admin/usuarios", icon: "👥", label: "Usuarios" }] : []),
    ...(esSuperAdmin ? [{ to: "/admin/configuracion", icon: "🛠️", label: "Configuración" }] : []),
    { to: "/admin/perfil", icon: "⚙️", label: "Mi Perfil" },
  ];

  const handleLogout = () => {
    cerrarSesion();
    navigate("/admin/login");
  };

  return (
      <div className="admin-layout">
        {sidebarOpen && (
            <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
        )}

        <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
          <div className="sidebar-header">
            <span className="sidebar-logo">🏠 Panel Admin</span>
            {esSuperAdmin && (
                <span style={{
                  fontSize: ".65rem", background: "rgba(201,169,110,.25)",
                  color: "var(--color-accent)", padding: ".15rem .5rem",
                  borderRadius: "999px", marginTop: ".25rem", display: "inline-block"
                }}>
              Super Admin
            </span>
            )}
          </div>

          <nav className="sidebar-nav">
            {NAV.map((item) => (
                <NavLink
                    key={item.to}
                    to={item.to}
                    className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                    onClick={() => setSidebarOpen(false)}
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
            ))}
          </nav>

          <div className="sidebar-footer">
            <div className="sidebar-user">
              <div className="sidebar-avatar">
                {usuario?.name?.charAt(0).toUpperCase()}
              </div>
              <div className="sidebar-user-info">
                <span className="sidebar-user-name">{usuario?.name}</span>
                <span className="sidebar-user-email">@{usuario?.username}</span>
              </div>
            </div>
            <button onClick={handleLogout} className="sidebar-logout">
              🚪 Cerrar sesión
            </button>
          </div>
        </aside>

        <main className="admin-content">
          <div className="admin-mobile-header">
            <button className="hamburger-admin" onClick={() => setSidebarOpen(true)}>☰</button>
            <span className="mobile-title">🏠 Panel Admin</span>
          </div>
          <Outlet />
        </main>
      </div>
  );
}